import { Scorecard } from './Scorecard'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { selectRoomSession } from '../../../../../store/meetingSummary/roomSession'
import React, { useEffect, useState } from 'react'
import { User } from '../../../../../models/User'
import { ScorecardResult } from '../../../../../models/Scorecard'
import { RoomSession } from '../../../../../models/Room'
import { Clients } from '../Common/Client'
import './Scorecards.scss'
import {
  selectClientProfileEventPollingEnabled,
  selectClientProfileLoading,
  selectClientProfileResults,
  selectShouldPollClientProfileEvents,
  selectShouldPollClientProfileResults,
  startClientProfileEventsPolling,
  startClientProfileResultsPolling,
  stopClientProfileEventsPolling,
  stopClientProfileResultsPolling,
} from '../../../../../store/meetingSummary/clientProfile'

const getUsersWithResult = (roomSession: RoomSession, scorecardResults: ScorecardResult[]) => {
  return roomSession.users
    .filter((u) => {
      return scorecardResults.find((s) => s.userId === u.id)
    })
    .sort((a, b) => a.name.localeCompare(b.name))
}

export const MeetingClientProfile: React.FC = () => {
  const roomSession = useAppSelector(selectRoomSession)
  const [currentClient, setCurrentClient] = useState<User | null>(null)
  const [usersWithResult, setUsersWithResult] = useState<User[]>([])
  const dispatch = useAppDispatch()

  const clientProfileLoading = useAppSelector(selectClientProfileLoading)
  const shouldPollEvents = useAppSelector(selectShouldPollClientProfileEvents)
  const pollingEnabled = useAppSelector(selectClientProfileEventPollingEnabled)
  const scorecardResults = useAppSelector(selectClientProfileResults)
  const shouldPoll = useAppSelector(selectShouldPollClientProfileResults)

  useEffect(() => {
    if (shouldPollEvents) {
      dispatch(startClientProfileEventsPolling())
    } else {
      dispatch(stopClientProfileEventsPolling())
    }
  }, [dispatch, shouldPollEvents])

  useEffect(() => {
    if (shouldPoll) {
      dispatch(startClientProfileResultsPolling())
    } else {
      dispatch(stopClientProfileResultsPolling())
    }
  }, [dispatch, shouldPoll])

  useEffect(() => {
    if (roomSession && roomSession.users && scorecardResults) {
      const users = getUsersWithResult(roomSession, scorecardResults)
      if (users) {
        setUsersWithResult(users)
        setCurrentClient(users[0])
      }
    }
  }, [roomSession, scorecardResults])

  if (!roomSession || !roomSession.users) {
    return null
  }

  if (clientProfileLoading || pollingEnabled) {
    return (
      <div className='d-flex px-4 py-3'>
        <div className='skeleton w-100 loading-result-skeleton' style={{ height: '24px' }} />
      </div>
    )
  }

  const handleUserClicked = (user: User) => {
    setCurrentClient(user)
  }

  if (!currentClient || !usersWithResult) {
    return <div className='paragraph-medium-extended zocks-text-gray-500 py-1 pe-4 ps-4'> No result available on this meeting.</div>
  }

  return (
    <>
      <div className='py-3 gap-2'>
        <Clients users={usersWithResult} userClicked={handleUserClicked} activeClient={currentClient!} />
      </div>
      <div className='pt-5 gap-2'>
        <Scorecard contact={currentClient} scorecardResults={scorecardResults!.filter((s) => s.userId === currentClient!.id)} />
      </div>
    </>
  )
}
